<div role="main">
  <app-header></app-header>

  <div class="col-md-3 offset-md-1">
    <div class="row">
      <span class="text-white-ref ref">Reference ID</span>
    </div>
    <div class="row">
      <span class="ref-id-no">{{service.referenceFileDetails.referenceId}}</span>
    </div>
  </div>
  <div class="emailfooter">
    <div class="col-sm-10 col-md-10 col-lg-10 offset-md-1">
      <form [formGroup]="emailForm" (ngSubmit)="next()">
        <div class="form-group mt-2 mb-2">
          <div class="d-flex align-items-center mb-2">
            <label class="text-white-ref">An Email Verification Code has been emailed to:</label> &nbsp;
            <span class="text-white-ref">{{ emailForm.get('validateEmail')?.value }}</span>
          </div>
          <div class="recaptcha-wrapper">
            <app-re-captcha (captchaEvent)="onCaptchaResolved($event)"></app-re-captcha>
          </div>

          <div class="d-flex align-items-center mb-2" *ngIf="captchaValidated">
            <label class="text-white me-2 mb-0">Enter the Code below:</label>
            <span class="text-danger mb-0" [style.display]="invalid ? 'inline' : 'none'">Entered Code is invalid</span>
          </div>

          <div class="col-sm-4 col-md-4 col-lg-4" >
            <span>
              <input type="text" class="form-control" id="email-code" (keypress)="enableSubmit()" (click)="enableSubmit()" placeholder="Email Code" formControlName="emailCode" name="emailCode" maxlength="6">
            </span>
          </div>

        </div>
      </form>
    </div>


    <div class="col-lg-11 col-md-11 col-sm-12 offset-md-1 captchaValidated" *ngIf="captchaValidated">
      <div class="col container--flex">
        <button type="button" class="btn btn-warn me-2"  id="dashboardButton" (click)="close()">Cancel</button>
        <button type="button" class="btn btn-warn me-2"  id="dashboardbackButton" (click)="back()">Back</button>
        <div [ngbTooltip]="!emailForm.get('emailCode')?.valid ? 'Please enter a valid 6-digit verification code' : null" container="body" [tooltipClass]="'tooltip-disabled'">
          <button class="btn btn-success me-2" type="submit" [disabled]="!emailForm.get('emailCode')?.valid" (click)="validateCode()">Click Here to Verify the Code Entered</button>
        </div>
        <span class="spinner-border text-light me-2" role="status" [style.display]="isVisible ? 'block' : 'none'"></span>
        <button class="btn btn-success me-2" type="submit" (click)="resendCode()">Resend Code</button>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
